// src/admin/AdminLogin.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";

const API_BASE = "https://api2.newstyle23.topindev.cloud";


export default function AdminLogin() {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE}/admin/login`, {
        username: user,
        password: pass,
      });

      localStorage.setItem("adminToken", res.data.token);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError("❌ Usuario o contraseña incorrectos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "radial-gradient(circle at top, #1f2937, #020617)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.5 }}
        style={{
          background: "rgba(15,23,42,0.9)",
          padding: "2rem",
          borderRadius: "1.5rem",
          border: "1px solid rgba(148,163,184,0.35)",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 25px 60px rgba(0,0,0,0.6)",
        }}
      >
        <h2 style={{ color: "white", textAlign: "center", marginBottom: "1.5rem", fontSize: "1.4rem" }}>
          🔐 Panel Admin · NewStyle23
        </h2>

        <form onSubmit={handleLogin}>
          <label style={labelStyle}>Usuario</label>
          <input
            type="text"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            placeholder=""
            disabled={loading}
            style={{...inputStyle, opacity: loading ? 0.6 : 1}}
            required
          />

          <label style={labelStyle}>Contraseña</label>
          <input
            type="password"
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            placeholder="••••••••"
            disabled={loading}
            style={{...inputStyle, opacity: loading ? 0.6 : 1}}
            required
          />

          {error && (
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              style={errorStyle}
            >
              {error}
            </motion.div>
          )}

          <motion.button
            type="submit"
            disabled={loading}
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.97 }}
            style={{
              ...buttonStyle,
              opacity: loading ? 0.6 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
          >
            {loading ? "Verificando..." : "Entrar al panel"}
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
}

const labelStyle = {
  color: "#e5e7eb",
  fontSize: "0.85rem",
  marginBottom: "0.3rem",
  display: "block",
};

const inputStyle = {
  width: "100%",
  padding: "0.6rem",
  marginBottom: "1rem",
  borderRadius: "0.75rem",
  border: "1px solid rgba(55,65,81,1)",
  background: "rgba(15,23,42,0.95)",
  color: "white",
  fontSize: "0.9rem",
};

const buttonStyle = {
  width: "100%",
  padding: "0.8rem",
  borderRadius: "999px",
  border: "none",
  background: "radial-gradient(circle at top left, #fbbf24, #b45309)",
  color: "#020617",
  fontWeight: 600,
  cursor: "pointer",
  marginTop: "0.5rem",
  fontSize: "1rem",
};

const errorStyle = {
  background: "rgba(239,68,68,0.15)",
  border: "1px solid rgba(239,68,68,0.6)",
  color: "#fecaca",
  padding: "0.6rem",
  borderRadius: "0.7rem",
  marginBottom: "1rem",
  fontSize: "0.9rem",
};